var repeatGuesses = (({
  baseGuesses,
  repeatCount
}) => baseGuesses * repeatCount);

export default repeatGuesses;
//# sourceMappingURL=repeat.esm.js.map
